var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/plus-big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/plus-big",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,20.049235 C40,20.890589 39.3179478,21.5726412 38.4765938,21.5726412 L21.5315077,21.5726412 L21.5315077,21.5726412 L21.5315077,38.4684923 C21.5315077,39.3143207 20.8458283,40 20,40 C19.1541717,40 18.4684923,39.3143207 18.4684923,38.4684923 L18.4684923,21.5726412 L18.4684923,21.5726412 L1.5234062,21.5726412 C0.682052188,21.5726412 1.0303615e-16,20.890589 0,20.049235 C-1.0303615e-16,19.207881 0.682052188,18.5258288 1.5234062,18.5258288 L18.4684923,18.5258288 L18.4684923,18.5258288 L18.4684923,1.53150765 C18.4684923,0.685679331 19.1541717,1.55376142e-16 20,0 C20.8458283,1.34711678e-15 21.5315077,0.685679331 21.5315077,1.53150765 L21.5315077,18.5258288 L21.5315077,18.5258288 L38.4765938,18.5258288 C39.3179478,18.5258288 40,19.207881 40,20.049235 Z",
    id: "+",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBig);
export default __webpack_public_path__ + "static/media/plus-big.a1537f22.svg";
export { ForwardRef as ReactComponent };